"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var Model_1 = require("../Model");
var REASON_CODE;
(function (REASON_CODE) {
    REASON_CODE["ADDRESS_NOT_FOUND"] = "ADDRESS_NOT_FOUND";
    REASON_CODE["DELIVERY_DAMAGED"] = "DELIVERY_DAMAGED";
    REASON_CODE["NO_TIME_LEFT_IN_TIMESLOT"] = "NO_TIME_LEFT_IN_TIMESLOT";
    REASON_CODE["RECIPIENT_NOT_AT_HOME"] = "RECIPIENT_NOT_AT_HOME";
    REASON_CODE["DRIVER_INVOLVED_IN_ACCIDENT"] = "DRIVER_INVOLVED_IN_ACCIDENT";
    REASON_CODE["REFUSED_BY_CUSTOMER"] = "REFUSED_BY_CUSTOMER";
    REASON_CODE["BUSINESS_CLOSED"] = "BUSINESS_CLOSED";
    REASON_CODE["BAD_ADDRESS"] = "BAD_ADDRESS";
    REASON_CODE["EXTREME_WEATHER_CONDITIONS"] = "EXTREME_WEATHER_CONDITIONS";
    REASON_CODE["PARCEL_MISSING"] = "PARCEL_MISSING";
    REASON_CODE["DELIVER_ADDRESS_NOT_ACCESSIBLE"] = "DELIVER_ADDRESS_NOT_ACCESSIBLE";
    REASON_CODE["SHIPMENT_MISSING"] = "SHIPMENT_MISSING";
    REASON_CODE["HEAVILY_DAMAGED"] = "HEAVILY_DAMAGED";
    REASON_CODE["TOO_HEAVY"] = "TOO_HEAVY";
    REASON_CODE["TOO_LARGE"] = "TOO_LARGE";
    REASON_CODE["NOT_PLANNED"] = "NOT_PLANNED";
    REASON_CODE["MAX_FAILED_DELIVERY_ATTEMPT"] = "MAX_FAILED_DELIVERY_ATTEMPT";
    REASON_CODE["MAX_OUT_OF_FREEZER_TIME"] = "MAX_OUT_OF_FREEZER_TIME";
})(REASON_CODE = exports.REASON_CODE || (exports.REASON_CODE = {}));
var ReasonCode = /** @class */ (function (_super) {
    __extends(ReasonCode, _super);
    function ReasonCode(id, code, description, nl, en) {
        var _this = _super.call(this, id) || this;
        _this.setCode = code;
        _this.setDescription = description;
        _this.setNl = nl;
        _this.setEn = en;
        return _this;
    }
    Object.defineProperty(ReasonCode.prototype, "getCode", {
        /***
         * GETTERS
         */
        get: function () {
            return this.code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReasonCode.prototype, "getDescription", {
        get: function () {
            return this.description;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReasonCode.prototype, "getEn", {
        get: function () {
            return this.en;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReasonCode.prototype, "getNl", {
        get: function () {
            return this.nl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReasonCode.prototype, "setCode", {
        /***
         * SETTERS
         */
        set: function (code) {
            this.code = code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReasonCode.prototype, "setDescription", {
        set: function (description) {
            this.description = description;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReasonCode.prototype, "setEn", {
        set: function (en) {
            this.en = en;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReasonCode.prototype, "setNl", {
        set: function (nl) {
            this.nl = nl;
        },
        enumerable: true,
        configurable: true
    });
    ReasonCode.fetch = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Model_1.Model.makeRequest("delivery/private/reason-code/" + id, Model_1.METHOD.GET, {
                        filter: {
                            relations: ['linkedState'],
                        },
                    })];
                case 1:
                    result = (_a.sent()).result;
                    return [2 /*return*/, new ReasonCode(result.id, result.code, result.description, result.nl, result.en)];
            }
        });
    }); };
    ReasonCode.fetchByStateName = function (name) { return __awaiter(_this, void 0, void 0, function () {
        var result, availableReasonCodes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Model_1.Model.makeRequest("/delivery/private/state", Model_1.METHOD.GET, {
                        filter: {
                            where: { name: name },
                            relations: ['availableReasonCodes'],
                        },
                    })];
                case 1:
                    result = (_a.sent()).result;
                    if (result.length === 0) {
                        throw new Error("No reason codes found for state " + name);
                    }
                    availableReasonCodes = result.pop().availableReasonCodes;
                    return [2 /*return*/, availableReasonCodes.map(function (reasonCode) { return new ReasonCode(reasonCode.id, reasonCode.code, reasonCode.description, reasonCode.nl, reasonCode.en); })];
            }
        });
    }); };
    ReasonCode.fetchByShipmentState = function (state) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Model_1.Model.makeRequest("/delivery/functions/get-reason-codes/" + state, Model_1.METHOD.GET)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.result || response];
            }
        });
    }); };
    return ReasonCode;
}(Model_1.Model));
exports.ReasonCode = ReasonCode;
